<template>
  <div>
    {{ i18n(translations.label) }}
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './StatusInformationRequired.translations'

const i18n = useI18n()
</script>
